<template>
  <div class="box">
    <div class="title" style="padding-top: 17px;margin-bottom: 25px;">论文</div>
    <div class="content">
        <div class="ring"><div v-for="(item,index) of list" :key="index">{{index+1}}</div></div>
        <div class="banner-image" id="ChartPaper" style="width:100%;height:183px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'patent',
  data () {
    return {
      list: []
    }
  },
  created () {
    this.drawChart();
  },
  methods: {
    drawChart () {
      const _self = this;
      this.post('/dataapi/open/nqi/fruit/bigScreenPaperCount').then(res => {
        _self.list = res.result;
        _self.typeList = res.result;
        _self.chart = echarts.init(document.getElementById('ChartPaper'));
        let xAxis = [];
        let value = [];
        let maxData = [];
        for (let item of _self.typeList) {
          xAxis.push(item.fruit_type);
          value.push({
            value: item.rs
          });
          maxData.push(item.rs)
        }
        let max = maxData[0];
        for (let i = 0; i < maxData.length; i++) {
          max = max > maxData[i] ? max : maxData[i]
        }
        _self.chart.setOption({
          grid: {
            top: '10%',
            right: '10%',
            left: '20%',
            bottom: '15%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function (params) {
              console.log(params);
              return params[1].name + '<br/>' +
                "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#0F87FA'></span>" + params[1].value + ' <br/>'
            }
          },
          xAxis: [{
            show: false
          }],
          yAxis: [{
            type: 'category',
            data: xAxis,
            margin: 15,
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#e2e9ff',
              textStyle: {
                fontSize: 12
              }
            }
          }, {
            type: 'category',
            axisTick: 'none',
            margin: 15,
            axisLine: {
              show: false
            },
            show: true,
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12'
              }
            },
            data: value
          }],
          series: [
            {
              name: 'back',
              type: 'bar',
              barWidth: 15,
              barGap: '-100%',
              data: value.map(() => { return (max * 1.5) }),
              itemStyle: {
                normal: {
                  color: 'rgba(24,31,68,1)',
                  barBorderRadius: [30, 30, 30, 30]
                }
              }

            },
            {
              type: 'bar',
              data: value,
              barWidth: 15,
              zlevel: 1,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                    offset: 0,
                    color: '#0F87FA ' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#00C0FE' // 100% 处的颜色
                  }], false),
                  barBorderRadius: [30, 30, 30, 30],
                  shadowBlur: 4
                }
              }
            }
          ]
        });
      });
    }
  }
}
</script>

<style scoped>
.box{
  background-image: url('../assets/images/contentBg-min.png');
  background-size: 100% 100%;
  width: 100%;
  height: 248px;
}
.title{
  width: 36px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #00FFF4;
  line-height: 25px;
  margin: 0 auto;
}
.content{
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.ring{
  width: 20px;
  padding-top: 30px;
  margin-left: 15px;
}
.ring >div {
  width: 20px;
  height: 20px;
  border: 2px solid #0292AC;
  border-radius: 50%;
  color: #00FFF4;
  text-align: center;
  font-size: 12px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/paper.vue